import apiAllUsers from '@/api/all-users'

const state = {
  error: null,
  isSubmitting: false
}

export const mutationTypes = {
  deleteAllUsersStart: '[delete all users] Create all users start',
  deleteAllUsersSuccess: '[delete all users] Create all users success',
  deleteAllUsersFailure: '[delete all users] Create all users failure'
}

export const actionTypes = {
  deleteAllUsers: '[delete all users] Create all users'
}

const mutations = {
  [mutationTypes.deleteAllUsersStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.deleteAllUsersSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.deleteAllUsersFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  }
}

const actions = {
  [actionTypes.deleteAllUsers](context, {id}) {
    context.commit(mutationTypes.deleteAllUsersStart)
    return new Promise(resolve => {
      apiAllUsers
        .deleteAllUsers(id)
        .then(response => {
          context.commit(mutationTypes.deleteAllUsersSuccess)
          resolve(response.data)
        })
        .catch(resolve => {
          context.commit(
            mutationTypes.deleteAllUsersFailure,
            resolve.response.data.errors
          )
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
